import { Button } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import CreateFeedback from "../CreateFeedback/CreateFeedback";
import Icon from "../Icon/Icon";
import { Props } from "./ErrorMessage.model";
import styles from "./ErrorMessage.module.scss";

const ErrorMessage = ({
	error,
	onRefresh,
	showReport
}: Props) => {

	const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

	const toggleFeedbackPopup = () => {
		setShowFeedbackPopup(value => !value);
	}

	return <>
		<div className={`${styles.errorMessageWrapper} ${error && styles.error}`}>
			<Icon name="woods" type="custom" color="white" width="200px" height="150px" />
			<h1><FormattedMessage id="errors.message" /></h1>
			<div className={styles.btnWrapper}>
				<Button type="primary" size="large" onClick={onRefresh}>
					<FormattedMessage id="buttons.refresh" />
				</Button>
				{showReport && <Button type="default" size="large" onClick={toggleFeedbackPopup}>
					<FormattedMessage id="buttons.reportError" />
				</Button>}
			</div>
		</div>
		{showFeedbackPopup && <CreateFeedback onClose={toggleFeedbackPopup} />}
	</>
};
export default ErrorMessage;